// extracted by mini-css-extract-plugin
export default {"buttons":"InputHeader_buttons__TG++j","activeButton":"InputHeader_activeButton__BazPC"};